import { fetcher } from '../utils'
import { ComponentInfoChatLinksVO, ComponentInfoLinkVO } from '@repo/types'

export default async (input: ComponentInfoChatLinksVO): Promise<ComponentInfoLinkVO[]> => {
  return await fetcher(`/api/componentInfo/chat/links`, 'POST', input)
}
